/* ==========================================================================
   MOUSHE SHOP \u2014 collection, product, quick add & cart (no dependencies)
   ========================================================================== */
(function () {
  'use strict';
  var d = document, w = window;
  var ROOT = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var reduceMotion = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function store(k, v) { try { if (v === undefined) return w.localStorage.getItem(k); w.localStorage.setItem(k, v); } catch (e) { return null; } }
  function lock(on) { d.body.classList.toggle('mh-lock', !!on); }

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = (w.mhMoneyFormat || 'Rs.{{amount}}').replace(/<[^>]*>/g, '');
    cents = parseInt(cents, 10) || 0;
    function n(dec, th, dp) {
      var p = (cents / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(dp);
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', v;
    switch (key) {
      case 'amount_no_decimals': v = n(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = n(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = n(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = n(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = n(0, ' ', '.'); break;
      default: v = n(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  w.mhMoney = money;

  /* ---------- Toast ---------- */
  function toast(html, isError) {
    var t = $('.mh-toast');
    if (!t) { t = d.createElement('div'); t.className = 'mh-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); d.body.appendChild(t); }
    t.innerHTML = html; t.classList.toggle('is-error', !!isError);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }

  /* ---------- Cart ---------- */
  var Cart = {
    add: function (body) {
      var isForm = body instanceof FormData;
      var headers = { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      if (!isForm) headers['Content-Type'] = 'application/json';
      return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: headers, body: body })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
    },
    refresh: function (open) {
      return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          var wrap = $('#halo-cart-sidebar .previewCart-wrapper');
          if (!wrap) {
            if (open) toast('Added to your bag \u2014 <a href="' + ROOT + 'cart">View bag</a>');
            return cart;
          }
          return fetch(ROOT + 'cart?view=ajax_side_cart', { cache: 'no-store' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              wrap.innerHTML = html;
              $$('[data-free-shipping-wrapper]').forEach(function (f) { f.dispatchEvent(new Event('change', { bubbles: true })); });
              d.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
              if (open) d.body.classList.add('cart-sidebar-show');
              return cart;
            });
        });
    }
  };
  w.mhCart = Cart;
  function errText(err) { return (err && (err.description || err.message)) || 'Sorry, this piece could not be added. Please try again.'; }

  /* ---------- Quick add (cards) ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mh-quick-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    Cart.add(JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-mh-quick-add'), 10), quantity: 1 }] }))
      .then(function () { b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1800); return Cart.refresh(true); })
      .catch(function (err) { toast(errText(err), true); })
      .then(function () { b.classList.remove('is-loading'); });
  });

  /* ---------- Metal / colour dots swap card image ---------- */
  function toneSwap(dot) {
    var card = dot.closest('[data-mh-card]'); var img = card && $('.mh-card__img1', card);
    if (!img) return;
    if (!img.hasAttribute('data-orig')) { img.setAttribute('data-orig', img.getAttribute('src') || ''); img.setAttribute('data-orig-set', img.getAttribute('srcset') || ''); }
    img.removeAttribute('srcset'); img.src = dot.getAttribute('data-mh-tone-img');
    card.classList.add('is-toned');
    $$('.mh-tone', card).forEach(function (t) { t.classList.toggle('is-active', t === dot); });
  }
  function toneReset(card) {
    var img = $('.mh-card__img1', card);
    if (!img || !img.hasAttribute('data-orig')) return;
    img.src = img.getAttribute('data-orig');
    if (img.getAttribute('data-orig-set')) img.setAttribute('srcset', img.getAttribute('data-orig-set'));
    card.classList.remove('is-toned');
    $$('.mh-tone', card).forEach(function (t) { t.classList.remove('is-active'); });
  }
  d.addEventListener('mouseover', function (e) { var t = e.target.closest && e.target.closest('[data-mh-tone-img]'); if (t) toneSwap(t); });
  d.addEventListener('click', function (e) { var t = e.target.closest('[data-mh-tone-img]'); if (t) { e.preventDefault(); toneSwap(t); } });
  d.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('[data-mh-card].is-toned');
    if (card && !card.contains(e.relatedTarget)) toneReset(card);
  });

  /* ======================================================================
     COLLECTION
     ====================================================================== */
  function initCollection(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = '1';
    var sid = sec.getAttribute('data-section-id');
    var mqMobile = w.matchMedia('(max-width: 989px)');

    // Grid view toggle
    function markView() {
      var cur = mqMobile.matches ? (sec.style.getPropertyValue('--cols-m') || getComputedStyle(sec).getPropertyValue('--cols-m')) : (sec.style.getPropertyValue('--cols') || getComputedStyle(sec).getPropertyValue('--cols'));
      cur = String(cur).trim();
      $$('[data-mh-view]', sec).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-mh-view') === cur); });
    }
    var sv = store('mhView'), svm = store('mhViewM');
    if (sv) sec.style.setProperty('--cols', sv);
    if (svm) sec.style.setProperty('--cols-m', svm);
    markView();
    mqMobile.addEventListener ? mqMobile.addEventListener('change', markView) : mqMobile.addListener(markView);
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mh-view]'); if (!b) return;
      var n = b.getAttribute('data-mh-view');
      if (mqMobile.matches) { sec.style.setProperty('--cols-m', n); store('mhViewM', n); }
      else { sec.style.setProperty('--cols', n); store('mhView', n); }
      markView();
    });

    // Description read more
    var desc = $('[data-mh-desc]', sec);
    if (desc) {
      var inner = $('.mh-col__desc-inner', desc), btn = $('[data-mh-desc-toggle]', desc);
      if (inner.scrollHeight > inner.clientHeight + 4) btn.hidden = false;
      btn.addEventListener('click', function () { var o = desc.classList.toggle('is-open'); btn.textContent = o ? 'Read less' : 'Read more'; });
    }

    // Filter drawer
    var drawer = $('[data-mh-filters]', sec);
    function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); lock(true); }
    function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); lock(false); }
    sec.addEventListener('click', function (e) {
      if (e.target.closest('[data-mh-filter-open]')) { e.preventDefault(); openDrawer(); }
      else if (e.target.closest('[data-mh-filter-close]')) { e.preventDefault(); closeDrawer(); }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(); });

    // Build URL from filters + sort
    function buildUrl() {
      var p = new URLSearchParams();
      var form = $('[data-mh-filter-form]', sec);
      if (form) new FormData(form).forEach(function (v, k) { if (k !== 'sort_by' && String(v).trim() !== '') p.append(k, v); });
      var sort = $('[data-mh-sort]', sec);
      if (sort) p.set('sort_by', sort.value);
      return w.location.pathname + (p.toString() ? '?' + p.toString() : '');
    }

    // Section rendering
    var busy = null;
    function render(url, push) {
      if (busy) busy.abort && busy.abort();
      busy = 'AbortController' in w ? new AbortController() : null;
      sec.classList.add('is-loading');
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid;
      fetch(fetchUrl, busy ? { signal: busy.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-mh-collection]', doc);
          if (!fresh) { w.location.href = url; return; }
          ['[data-mh-results]', '[data-mh-active]'].forEach(function (sel) {
            var a = $(sel, sec), b = $(sel, fresh); if (a && b) a.innerHTML = b.innerHTML;
          });
          var fa = $('[data-mh-filter-form]', sec), fb = $('[data-mh-filter-form]', fresh);
          if (fa && fb) {
            var openIdx = $$('details', fa).map(function (x) { return x.open; });
            fa.innerHTML = fb.innerHTML;
            $$('details', fa).forEach(function (x, i) { if (openIdx[i] !== undefined) x.open = openIdx[i]; });
          }
          var srcCounts = $$('[data-mh-count]', fresh);
          $$('[data-mh-count]', sec).forEach(function (el, i) { if (srcCounts[i]) el.textContent = srcCounts[i].textContent; });
          var ac = $('[data-mh-active-count]', sec), acn = $('[data-mh-active-count]', fresh);
          if (ac && acn) { ac.textContent = acn.textContent; ac.hidden = acn.hidden; }
          if (push !== false) w.history.pushState({ mhCol: true }, '', url);
          w.mhInit && w.mhInit(sec);
        })
        .catch(function (err) { if (err && err.name === 'AbortError') return; w.location.href = url; })
        .then(function () { sec.classList.remove('is-loading'); });
    }
    var tmr;
    sec.addEventListener('change', function (e) {
      if (e.target.closest('[data-mh-filter-form]') || e.target.matches('[data-mh-sort]')) {
        clearTimeout(tmr);
        var delay = e.target.type === 'number' ? 600 : 120;
        tmr = setTimeout(function () { render(buildUrl()); }, delay);
      }
    });
    sec.addEventListener('submit', function (e) { if (e.target.matches('[data-mh-filter-form]')) { e.preventDefault(); render(buildUrl()); } });
    sec.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-mh-link]'); if (!a) return;
      e.preventDefault(); render(a.getAttribute('href'));
      if (!drawer || !drawer.contains(a)) { var top = sec.querySelector('[data-mh-bar]'); top && top.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }
    });
    w.addEventListener('popstate', function () { render(w.location.href, false); });

    // Load more
    sec.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mh-load-more]'); if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var url = btn.getAttribute('href');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = $('[data-mh-grid]', sec), items = $$('[data-mh-grid] > .mh-col__item', doc);
          items.forEach(function (li, n) { li.style.setProperty('--i', n); li.classList.add('is-new'); grid.appendChild(li); });
          var nb = $('[data-mh-load-more]', doc);
          var shown = $$('.mh-col__item', grid).length + 0;
          var total = parseInt(btn.getAttribute('data-total'), 10) || shown;
          var sEl = $('[data-mh-shown]', sec); if (sEl) sEl.textContent = Math.min(shown, total);
          var bar = $('[data-mh-progress]', sec); if (bar) bar.style.width = Math.min(100, shown / total * 100) + '%';
          var pages = $('.mh-col__pages', sec), np = $('.mh-col__pages', doc); if (pages && np) pages.innerHTML = np.innerHTML;
          if (nb) { btn.setAttribute('href', nb.getAttribute('href')); btn.classList.remove('is-loading'); }
          else btn.remove();
          w.mhInit && w.mhInit(grid);
        })
        .catch(function () { w.location.href = url; });
    });

    // Sticky toolbar sits right under the sticky header
    var bar = $('[data-mh-bar]', sec);
    function syncTop() { var h = $('.mh-section-header') || $('.mh-header'); if (h && bar) bar.style.setProperty('--mh-sticky-top', Math.round(h.getBoundingClientRect().height) + 'px'); }
    syncTop(); w.addEventListener('resize', syncTop, { passive: true }); w.addEventListener('load', syncTop);
    if (bar && 'IntersectionObserver' in w) {
      var sentinel = d.createElement('div'); sentinel.style.height = '1px'; bar.parentNode.insertBefore(sentinel, bar);
      new IntersectionObserver(function (en) { bar.classList.toggle('is-stuck', !en[0].isIntersecting); }, { rootMargin: '-120px 0px 0px 0px' }).observe(sentinel);
    }
  }

  /* ======================================================================
     PRODUCT
     ====================================================================== */
  function initProduct(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = '1';
    var jsonEl = $('[data-mh-product-json]', sec);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    rvRecord(data.handle);
    var form = $('form[data-mh-form]', sec) || $('form[action*="/cart/add"]', sec);
    var idInput = $('[data-mh-variant-id]', sec);
    var atc = $('[data-mh-atc]', sec);
    var track = $('[data-mh-track]', sec);
    var gallery = sec.getAttribute('data-gallery');
    var mqMobile = w.matchMedia('(max-width: 989px)');
    function isSlider() { return gallery === 'thumbs' || mqMobile.matches; }
    function slides() { return $$('.mh-gal__slide', track); }

    /* --- Gallery --- */
    var cur = 0;
    function setActive(i) {
      var s = slides(); if (!s[i]) return;
      cur = i;
      s.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
      var mid = s[i].getAttribute('data-media-id');
      $$('[data-mh-thumb]', sec).forEach(function (t) {
        var on = t.getAttribute('data-media-id') === mid;
        t.classList.toggle('is-active', on);
        if (on && t.parentNode.scrollTo) {
          var p = t.parentNode;
          if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: t.offsetTop - p.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
        }
      });
      var c = $('[data-mh-cur]', sec); if (c) c.textContent = i + 1;
    }
    function goTo(i, smooth) {
      var s = slides(); if (!track || !s.length) return;
      i = (i + s.length) % s.length;
      if (isSlider()) track.scrollTo({ left: s[i].offsetLeft - s[0].offsetLeft, behavior: smooth === false || reduceMotion ? 'auto' : 'smooth' });
      else s[i].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      setActive(i);
    }
    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        if (!isSlider()) return;
        clearTimeout(st);
        st = setTimeout(function () { var s = slides(); var w0 = s[0] ? s[0].getBoundingClientRect().width : track.clientWidth; setActive(Math.round(track.scrollLeft / Math.max(w0, 1))); }, 60);
      }, { passive: true });
    }
    var p = $('[data-mh-prev]', sec), n = $('[data-mh-next]', sec);
    p && p.addEventListener('click', function () { goTo(cur - 1); });
    n && n.addEventListener('click', function () { goTo(cur + 1); });
    $$('[data-mh-thumb]', sec).forEach(function (t, k) {
      var s0 = slides()[k]; if (s0) t.setAttribute('data-media-id', s0.getAttribute('data-media-id'));
      t.addEventListener('click', function () {
        var mid = t.getAttribute('data-media-id');
        var idx = slides().findIndex(function (s) { return s.getAttribute('data-media-id') === mid; });
        if (idx > -1) goTo(idx);
      });
    });
    function showMedia(mediaId) {
      if (!mediaId || !track) return;
      var s = slides(); var idx = s.findIndex(function (el) { return el.getAttribute('data-media-id') === String(mediaId); });
      if (idx < 0) return;
      if (!isSlider()) {
        if (idx !== 0) { track.insertBefore(s[idx], s[0]); }
        setActive(0);
        var top = track.getBoundingClientRect().top;
        if (top < 0) w.scrollTo({ top: w.scrollY + top - 140, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else goTo(idx);
    }

    /* --- Lightbox with zoom --- */
    var lb = $('[data-mh-lightbox]', sec), lbTrack = lb && $('[data-mh-lb-track]', lb);
    if (lb) {
      d.body.appendChild(lb);
      function lbOpen(origIndex) {
        var target = $('.mh-lb__slide[data-index="' + origIndex + '"]', lb);
        lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); lock(true);
        $$('img[loading="lazy"]', lb).forEach(function (im) { im.loading = 'eager'; });
        requestAnimationFrame(function () { if (target) lbTrack.scrollTo({ left: target.offsetLeft, behavior: 'auto' }); });
        var c = $('[data-mh-lb-close]', lb); c && c.focus({ preventScroll: true });
      }
      function lbClose() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); lock(false); $$('.is-zoomed', lb).forEach(function (z) { z.classList.remove('is-zoomed'); }); }
      sec.addEventListener('click', function (e) {
        var z = e.target.closest('[data-mh-zoom]'); if (!z) return;
        var slide = z.closest('.mh-gal__slide');
        lbOpen(slide ? slide.getAttribute('data-index') : z.getAttribute('data-mh-zoom'));
      });
      $('[data-mh-lb-close]', lb).addEventListener('click', lbClose);
      $('[data-mh-lb-prev]', lb).addEventListener('click', function () { lbTrack.scrollBy({ left: -lbTrack.clientWidth, behavior: 'smooth' }); });
      $('[data-mh-lb-next]', lb).addEventListener('click', function () { lbTrack.scrollBy({ left: lbTrack.clientWidth, behavior: 'smooth' }); });
      d.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') lbClose();
        if (e.key === 'ArrowRight') lbTrack.scrollBy({ left: lbTrack.clientWidth, behavior: 'smooth' });
        if (e.key === 'ArrowLeft') lbTrack.scrollBy({ left: -lbTrack.clientWidth, behavior: 'smooth' });
      });
      lbTrack.addEventListener('click', function (e) {
        var s = e.target.closest('.mh-lb__slide'); if (!s || w.matchMedia('(hover: none)').matches) return;
        if (e.target.tagName !== 'IMG') { lbClose(); return; }
        s.classList.toggle('is-zoomed');
        if (s.classList.contains('is-zoomed')) pan(e, s);
      });
      function pan(e, s) {
        var im = $('img', s), r = s.getBoundingClientRect();
        im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      }
      lbTrack.addEventListener('mousemove', function (e) { var s = e.target.closest('.mh-lb__slide.is-zoomed'); if (s) pan(e, s); });
    }

    /* --- Variants --- */
    var optionSets = $$('[data-mh-option]', sec);
    function selected() { return optionSets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(opts) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function paintAvailability() {
      var opts = selected();
      optionSets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var v = findVariant(test);
          var anyWithValue = data.variants.some(function (x) { return x.options[i] === inp.value && x.available; });
          var lab = $('label[for="' + inp.id + '"]', fs);
          if (lab) {
            lab.classList.toggle('is-soldout', !!v && !v.available);
            lab.classList.toggle('is-missing', !v && !anyWithValue);
          }
        });
      });
    }
    function setText(sel, txt) { $$(sel, sec).concat(sticky ? $$(sel, sticky) : []).forEach(function (el) { el.textContent = txt; }); }
    function applyVariant(v) {
      var price = $('[data-mh-price-now]', sec), was = $('[data-mh-price-was]', sec), save = $('[data-mh-price-save]', sec);
      var stickyBtn = $('[data-mh-sticky-add]', d);
      if (!v) {
        if (atc) { atc.disabled = true; setText('[data-mh-atc-label]', 'Unavailable'); }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      var sale = v.compare_at_price > v.price;
      if (price) { price.textContent = money(v.price); price.classList.toggle('is-sale', sale); }
      if (was) { was.hidden = !sale; was.textContent = sale ? money(v.compare_at_price) : ''; }
      if (save) { save.hidden = !sale; save.textContent = sale ? 'Save ' + money(v.compare_at_price - v.price) : ''; }
      setText('[data-mh-atc-price]', money(v.price));
      setText('[data-mh-sticky-price]', money(v.price));
      setText('[data-mh-sticky-variant]', v.title + ' \u00b7 ');
      if (atc) { atc.disabled = !v.available; setText('[data-mh-atc-label]', v.available ? 'Add to bag' : 'Sold out'); }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      var stock = $('[data-mh-stock]', sec);
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        var st = $('[data-mh-stock-text]', stock);
        st.textContent = v.available ? st.getAttribute('data-in') : 'Currently sold out \u2014 message us to reserve';
      }
      if (v.image) { var si = $('[data-mh-sticky-img]', d); if (si) { si.removeAttribute('srcset'); si.src = v.image; } }
      if (v.media_id) showMedia(v.media_id);
      try { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState({}, '', u.toString()); } catch (e) {}
    }
    optionSets.forEach(function (fs) {
      fs.addEventListener('change', function (e) {
        var val = $('[data-mh-opt-value]', fs); if (val) val.textContent = e.target.value;
        paintAvailability();
        applyVariant(findVariant(selected()));
      });
    });
    if (optionSets.length) paintAvailability();

    /* --- Quantity --- */
    var qty = $('[data-mh-qty]', sec);
    if (qty) {
      var qi = $('input', qty);
      $('[data-mh-qty-minus]', qty).addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); });
      $('[data-mh-qty-plus]', qty).addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; });
    }

    /* --- Add to bag --- */
    var err = $('[data-mh-error]', sec);
    if (form) {
      form.addEventListener('submit', function (e) {
        if (e.defaultPrevented) return;
        e.preventDefault();
        if (!atc || atc.classList.contains('is-loading')) return;
        if (err) err.hidden = true;
        atc.classList.add('is-loading');
        Cart.add(new FormData(form))
          .then(function () {
            atc.classList.add('is-done');
            var lbl = $('[data-mh-atc-label]', atc), old = lbl.textContent; lbl.textContent = 'Added to bag';
            setTimeout(function () { atc.classList.remove('is-done'); lbl.textContent = old; }, 1800);
            return Cart.refresh(true);
          })
          .catch(function (x) { if (err) { err.textContent = errText(x); err.hidden = false; } else toast(errText(x), true); })
          .then(function () { atc.classList.remove('is-loading'); });
      });
    }

    /* --- Sticky bar --- */
    var sticky = $('[data-mh-sticky]', sec);
    if (sticky) {
      d.body.appendChild(sticky);
      var sBtn = $('[data-mh-sticky-add]', sticky);
      sBtn.addEventListener('click', function () {
        if (optionSets.length > 1 && !findVariant(selected())) { $('[data-mh-options]', sec).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form) { if (form.requestSubmit) form.requestSubmit(atc || undefined); else atc && atc.click(); }
      });
      // Show while scrolling the product page whenever the main "Add to bag" button is out of view
      var ticking = false;
      function previewOffset() {
        var el = d.getElementById('PBarNextFrameWrapper') || d.getElementById('preview-bar-iframe') || d.querySelector('[id^="PBar"]');
        if (!el) return 0;
        var r = el.getBoundingClientRect();
        return (r.height && r.bottom >= w.innerHeight - 2) ? Math.round(r.height) : 0;
      }
      function syncSticky() {
        ticking = false;
        var show = false;
        if (w.scrollY > 280) {
          if (!atc) show = true;
          else { var r = atc.getBoundingClientRect(); show = !(r.top < w.innerHeight && r.bottom > 0); }
        }
        if (show) sticky.style.bottom = previewOffset() + 'px';
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        d.body.classList.toggle('mh-sticky-on', show);
      }
      w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); } }, { passive: true });
      w.addEventListener('resize', syncSticky, { passive: true });
      syncSticky();
    }

    /* --- Copy link --- */
    var cp = $('[data-mh-copy]', sec);
    cp && cp.addEventListener('click', function () {
      var t = cp.getAttribute('data-mh-copy'), msg = $('[data-mh-copied]', cp);
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { msg.hidden = false; setTimeout(function () { msg.hidden = true; }, 1600); }).catch(function () { w.prompt('Copy link', t); });
    });

    // Hide size-guide link if the guide modal is not on the page
    $$('.mh-opt__guide', sec).forEach(function (b) { if (!d.getElementById(b.getAttribute('data-mh-modal-open'))) b.hidden = true; });
  }




  /* ---------- Countdown (sale end, Pakistan time unless a timezone is given) ---------- */
  function initCountdown(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var raw = (el.getAttribute('data-mh-countdown') || '').trim().replace(' ', 'T');
    if (!raw) return;
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw += (raw.length <= 10 ? 'T23:59:59' : (raw.length === 16 ? ':00' : '')) + '+05:00';
    var end = Date.parse(raw); if (isNaN(end)) return;
    var dd = $('[data-d]', el), hh = $('[data-h]', el), mm = $('[data-m]', el), ss = $('[data-s]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      el.hidden = false;
      dd.textContent = pad(Math.floor(left / 86400)); hh.textContent = pad(Math.floor(left % 86400 / 3600));
      mm.textContent = pad(Math.floor(left % 3600 / 60)); ss.textContent = pad(left % 60);
    }
    var timer = setInterval(tick, 1000); tick();
  }

  /* ---------- Cart page ---------- */
  function initCartPage(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = '1';
    var sid = sec.getAttribute('data-section-id'), t;
    function change(line, qty) {
      sec.classList.add('is-loading');
      fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function () { return fetch(ROOT + 'cart?section_id=' + sid, { cache: 'no-store' }); })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-mh-cart]', doc);
          if (fresh) sec.innerHTML = fresh.innerHTML;
          Cart.refresh(false);
        })
        .catch(function (err) { toast(errText(err), true); })
        .then(function () { sec.classList.remove('is-loading'); });
    }
    sec.addEventListener('click', function (e) {
      var li = e.target.closest('[data-line]'); if (!li) return;
      var inp = $('[data-mh-line-qty]', li), line = parseInt(li.getAttribute('data-line'), 10);
      if (e.target.closest('[data-mh-line-remove]')) { e.preventDefault(); li.classList.add('is-removing'); change(line, 0); return; }
      var d = e.target.closest('[data-mh-line-minus]') ? -1 : (e.target.closest('[data-mh-line-plus]') ? 1 : 0);
      if (!d) return;
      inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + d);
      clearTimeout(t); t = setTimeout(function () { change(line, parseInt(inp.value, 10)); }, 350);
    });
    sec.addEventListener('change', function (e) {
      if (!e.target.matches('[data-mh-line-qty]')) return;
      var li = e.target.closest('[data-line]');
      change(parseInt(li.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'mhRecent';
  function rvList() {
    var list = [];
    try { list = JSON.parse(store(RV_KEY) || '[]') || []; } catch (e) { list = []; }
    if (!list.length) { var old = store('shopify_recently_viewed'); if (old) list = old.split(' ').filter(Boolean); }
    return list;
  }
  function rvRecord(handle) {
    if (!handle) return;
    var list = rvList().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    store(RV_KEY, JSON.stringify(list.slice(0, 16)));
  }
  function initRecent(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var cur = el.getAttribute('data-current'), limit = parseInt(el.getAttribute('data-limit'), 10) || 8;
    var handles = rvList().filter(function (h) { return h && h !== cur; }).slice(0, limit);
    if (!handles.length) return;
    var listEl = $('[data-mh-rv-list]', el);
    Promise.all(handles.map(function (h) {
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?view=mh-card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var html = htmls.filter(function (x) { return x && x.indexOf('data-mh-card') > -1; }).join('');
      if (!html) return;
      listEl.innerHTML = html;
      el.hidden = false;
      w.mhInit && w.mhInit(el);
      var sc = $('[data-mh-scroller]', el) || listEl; sc.dispatchEvent(new Event('scroll'));
      w.dispatchEvent(new Event('resize'));
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecs(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    if ($('.mh-container', el)) return;
    var url = el.getAttribute('data-url'); if (!url) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-mh-recs]', doc);
        if (fresh && $('.mh-container', fresh)) { el.innerHTML = fresh.innerHTML; el.classList.add('is-loaded'); w.mhInit && w.mhInit(el); }
        else { el.remove(); }
      }).catch(function () { el.remove(); });
    };
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(el);
    } else load();
  }

  function init(scope) {
    scope = scope || d;
    $$('[data-mh-collection]', scope).forEach(initCollection);
    $$('[data-mh-product]', scope).forEach(initProduct);
    $$('[data-mh-recs]', scope).forEach(initRecs);
    $$('[data-mh-rv]', scope).forEach(initRecent);
    $$('[data-mh-cart]', scope).forEach(initCartPage);
    $$('[data-mh-countdown]', scope).forEach(initCountdown);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
